import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Image from "components/image";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/centralian-pythons.json";
import { animalGridFromJson } from "hooks/useGallery";
import husbandryImg from "img/centralians/Centralian Pythons.png";


const animalGridData = animalGridFromJson(collectionMeta);

const CentralianPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Centralian Pythons (Morelia bredli)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/centralian-pythons" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        I have two of the "pure hypo" Centralian, or Bredl's pythons from Nick Mutton and t
        hey are absolutely
        gorgeous animals. I had heard that Bredl's were the tamest carpet
        pythons but apparently the hypomelanistic gene that I've bought into can
        be a bit flighty. Still, I have never been bitten by one - partly
        because I can dodge their strikes so well - but they are calming down
        with time. So maybe they have to get through the nippy phase that all
        carpet pythons go through in their first two years or so.
      </BodyText>

      <BodyText>
        Mine are in cages which have perches and are close to the
        door in and out of my reptile room so they are on display constantly and
        are amazing to see. I hope to breed them at some point.
      </BodyText>

      <h1>Husbandry</h1>
      <Image src={husbandryImg} />
      <BodyText>
        See{" "}
        <Link to="/husbandry-charts">how to read the husbandry charts</Link>.
      </BodyText>

      <h3>Temperatures, Humidity, and Light</h3>
      <BodyText>
        As you can see in the chart above, I keep mine with a pretty significant difference
        between daytime and nighttime temperatures. Only the diamond pythons have a similar
        system. For most of the year, my Centralian pythons get a daytime high of about 80-82F 
        and then at night their temperature drops down to whatever the room gets to, 
        which is usually 68-70F. I'll explain the brumation temperatures in the Breeding section.
      </BodyText>
      <BodyText>
        In the Spring time after the snakes come out of their cooling period and have gone back
        to their higher, year-round temperatures, I spray their cages more frequently so that
        they have higher humidity.
      </BodyText>

      <h3>Feeding</h3>
      <BodyText>
        Feeding Centralian pythons is very simple. Mine eat frozen-thawed rodents. As you see
        in the chart there are times during the year when I feed the female more frequently than
        at other times of the year. This is to help prepare her for breeding or for carrying
        eggs. However, since I have not 
        bred them yet I expect this chart to change as I get more experience working with them.
      </BodyText>
      
      <h3>Breeding</h3>
      <BodyText>
        As I have noted I have not successfully bred these yet. But what I am doing is putting
        the adults in a room during the winter that gets pretty cold at night, but then giving them 
        a few hours of heat during the day. I feed the female sparingly during this cooldown
        period, and I also pair them together. They stay together until I am sure the female is
        gravid. 
      </BodyText>
      <BodyText>  
        Again, I will update the chart as I refine the process.
      </BodyText>

      <PageGallery slug="centralian-pythons" maxWidth="900" />
    </ContentBox>
  );
};

export default CentralianPython;
